import { gql } from "apollo-boost"

export const getComments = gql`
  query Comments($entities: [CommentEntitiesInputType!]!) {
    Comments(entities: $entities) {
      id
      fieldName
      userRol
      User
      createdAt
      reviewed
      revision
      comment
      type
      submission
      consultant
      beneficiary
      indicator
      concept
      humanResource
      specificObjective
      activity
      sustainabilityDetails
      projectMonthStatus
      financialStatementMonth
      parentCommentId
    }
  }
`
